import { showPauseButton } from '../state/ui-store';
import { onPlayPauseStateChange } from './on-play-pause-state-change';

export const pauseGoviePlayback = () => {
  showPauseButton();
  onPlayPauseStateChange();
};
